module.exports = __webpack_public_path__ + "static/img/3.9f95e22.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/4/zh/3.png
// module id = HhmB
// module chunks = 0